/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinList.vue?vue&type=template&id=9f0e0870&scoped=true"
import script from "./digitalTwinList.vue?vue&type=script&lang=js"
export * from "./digitalTwinList.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinList.vue?vue&type=style&index=0&id=9f0e0870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0e0870",
  null
  
)

export default component.exports